module.exports = __webpack_public_path__ + "static/media/business-resource.0c01dd30.png";